import Request from '../../../../../src/core/gd/data/request'

export default class ApiDesktopNotifications {

    constructor() {}

    test() {
        return new Request(this,'POST','push/fcm/test',{});
    }

    deleteMessagingToken(messagingToken:string) {
        return new Request(this, 'post', 'push/fcm/delete', {
            token: messagingToken
        });
    }

    saveMessagingToken(messagingToken:string, device:string) {
        return new Request(this, 'post', 'push/fcm/save', {
            token: messagingToken,
            platform: 'web',
            device: device
        });
    }

}
